import React from 'react';
import Button from '../atom/Button';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const ModalArea = styled.section`
  width: 100%;
  max-width: 590px;
  margin: 0 auto;
  box-sizing: border-box;
  border-radius: 0.3rem;
  background-color: #fff;
  overflow: hidden;
  height: 230px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Modal = (props: any) => {
  const navigate = useNavigate();
  const { open, formData } = props;
  const clickBtnOk = () => {
    navigate('/UserVocDetail', { state: formData });
  };
  return (
    <div className={open ? 'openModal modal' : 'modal'}>
      {open ? (
        <ModalArea>
          {/* {checkCapcha === false ? (
            <Captcha setCheckCapcha={setCheckCapcha} />
          ) : ( */}
          <>
            <main>{props.children}</main>
            <Button
              onClick={clickBtnOk}
              text={'확인'}
              type={'submit'}
              backgroundColor={'#388fc0'}
              fontColor={'white'}
              borderRadius={'5px'}
              width={'100px'}
              marginTop={'8px'}
            />
          </>
          {/* )} */}
        </ModalArea>
      ) : null}
    </div>
  );
};

export default Modal;
